import React, { useEffect, useState } from "react";
import useBulkAssigneeStore from "./store";
import { Table, Tooltip, Switch, Button, Input, Pagination } from "antd";
import { DeleteOutlined, SearchOutlined } from "@ant-design/icons";
import { toast } from "react-toastify";

function UpdateAssignee() {
  const {
    resolveAssigneeData,
    getResolveAssigneeData,
    updateAssigneeData,
    deleteAssigneeData,
    resolveAssigneeLoading,
    deleteAssigneeLoading,
    currentPage,
    totalPages,
    searchQuery,
  } = useBulkAssigneeStore();

  const [search, setSearch] = useState(searchQuery);
  const [page, setPage] = useState(currentPage);

  useEffect(() => {
    getResolveAssigneeData(page, 10, search);
  }, [page]); 

  const handleToggleResolve = (data) => {
    updateAssigneeData({
      email: data.email,
      firstName: data.firstName,
      userId: data.userId,
      isResolved: !data.isResolved
    }, toast);
  };

  const handleDeleteAssignee = (userId) => {
    deleteAssigneeData(userId, toast);
  };

  const validateSearchInput = (input) => {
    const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}|^[a-zA-Z0-9\s]+$/;
    return regex.test(input);
  };

  const handleSearch = () => {
    if (!validateSearchInput(search)) {
      toast.error("Invalid search input. Only names, numbers, and valid email formats are allowed.");
      return;
    }
    setPage(1);
    getResolveAssigneeData(1, 10, search);
  };

  const handlePageChange = (page) => {
    setPage(page);
    getResolveAssigneeData(page, 10, search);
  };

  const columns = [
    {
      title: "Name",
      dataIndex: "firstName",
      key: "name",
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
    },
    {
      title: "Is Resolved",
      key: "isResolved",
      render: (record) => (
        <Switch
          checked={record.isResolved}
          onChange={() => handleToggleResolve(record)}
          checkedChildren="Resolved"
          unCheckedChildren="Unresolved"
        />
      ),
    },
    {
      title: "Actions",
      key: "actions",
      render: (record) => (
        <>
          <Tooltip title="Delete Assignee">
            <Button
              type="danger"
              icon={<DeleteOutlined />}
              onClick={() => handleDeleteAssignee(record.userId)}
              loading={deleteAssigneeLoading}
            />
          </Tooltip>
        </>
      ),
    },
  ];

  return (
    <div>
      <Input
        placeholder="Search by name or email"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        style={{ marginBottom: 20, width: 300 }}
        addonAfter={<SearchOutlined onClick={handleSearch} />}
      />
      <Table
        columns={columns}
        dataSource={resolveAssigneeData || []}
        loading={resolveAssigneeLoading}
        rowKey="_id"
        pagination={false}
      />
      <Pagination
        current={page}
        total={totalPages * 10}
        onChange={handlePageChange}
        style={{ marginTop: 20 }}
        showSizeChanger={false}
      />
    </div>
  );
}

export default UpdateAssignee;